module.exports = __webpack_public_path__ + "img/bag_experience.2c68b21e.png";